import { Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";
import { LoginGuard } from "./guards/login.guard";
import { GeoRequiredGuard } from "./guards/geo-required.guard";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";
import { RegisterComponent } from "./pages-originals/register/register.component";
import { CheckInsComponent } from "./pages/compras/compras.component";
import { LoginComponent } from "./pages/login/login.component";
import { CompanyProfileComponent } from "./pages/company-profile/company-profile.component";
import { CashbackComponent } from "./pages/cashback/cashback.component";
import { CashbackSettingsComponent } from "./pages/cashback-settings/cashback-settings.component";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      { path: "login", canActivate: [LoginGuard], component: LoginComponent },
      {
        path: "register",
        canActivate: [LoginGuard],
        component: RegisterComponent,
      },
    ],
  },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "dashboard",
        canActivate: [GeoRequiredGuard],
        loadComponent: () =>
          import("./pages/dashboard/dashboard.component").then(
            (m) => m.DashboardComponent
          ),
      },
      { path: "compras", canActivate: [GeoRequiredGuard], component: CheckInsComponent },
      { path: "cashback", canActivate: [GeoRequiredGuard], component: CashbackComponent },
      { path: "company-profile", component: CompanyProfileComponent },
      { path: "cashback-settings", component: CashbackSettingsComponent },
    ],
  },
  { path: "**", redirectTo: "/dashboard" },
];
